export default "__VITE_ASSET__68a9b76d__"